import type { UUID } from './identifier';

export interface Fleet {
  id: UUID;
  name: string;
  active: boolean;
}

export interface FleetSize {
  /**
   * small
   * medium: 50 devices
   * large: 250 devices
   * xlarge: more than 250 devices (key accounts)
   */
  size: 'small' | 'medium' | 'large' | 'xlarge';
  smallOrMedium: boolean;
  largeOrXlarge: boolean;
  total: number;
}

export interface FuscaFleetShippingInfo {
  address: string;
  contactEmail: string;
  contactPhone: string;
}

export enum FuscaFleetAddressType {
  SHIPPING = 'SHIPPING',
}

export interface FuscaFleetAddress {
  id?: UUID;
  addressType: FuscaFleetAddressType;
  zipCode: string;
  city: string;
  uf: string;
  neighborhood: string;
  street: string;
  number?: string;
  complement?: string;
  phone: string;
  email: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface FuscaFleetAddressRequest {
  id?: UUID;
  address_type: FuscaFleetAddressType;
  zip_code: string;
  city: string;
  uf: string;
  neighborhood: string;
  street: string;
  number?: string;
  complement?: string;
  phone: string;
  email: string;
  created_at?: string;
  updated_at?: string;
}

export interface FuscaFleetInfo {
  id: UUID;
  name: string;
  shipping: FuscaFleetShippingInfo;
  addresses: FuscaFleetAddress[];
}

export enum HiredProduct {
  TELEMETRY = 'telemetry',
  CAM = 'cam',
  CAM_PRO = 'cam_pro',
  CAM_MULTI = 'cam_multi',
  REDE_CAN = 'rede_can',
}
